// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__312Bn","form":"styles_form__jTXNx"};